import React from "react";

export function Play() {
	return (
		<>
			<h1>Play</h1>
		</>
	);
}
